import { Mock } from '@mock/model';
import {
  blogArticleMock,
  blogB2cInspirationMock,
  blogB2cMock,
  carteOpportunitesPageMock,
  catalogueConsultationMock,
  catalogueMock,
  categoriesFacadesMock,
  coinRepasMock,
  confidentialiteMock,
  confirmationEnvoiFormulaireContactMock,
  contactB2bMock,
  contactMock,
  corpsDeMeubleMock,
  cuisineSurMesureMock,
  detailsCusineMock,
  detailTutoMock,
  erreurMock,
  estimateurBudgetMock,
  estimateurBudgetRecapMock,
  estimateurBudgetStep1Mock,
  faqDetailsMock,
  faqListingMock,
  franchiseChiffresMock,
  franchiseCuisinistesMock,
  franchiseEtapesProjetMock,
  franchiseHomepageMock,
  homepageMock,
  laPoseMock,
  laPosePersoMock,
  laPoseProMock,
  listingCuisineMock,
  listingFacadesMock,
  listingMagasinPageMock,
  lpSemPageFiltreMock,
  lpSemSommaireMock,
  lpSimpleMock,
  magasinMock,
  mentionsLegalesMock,
  meublesImageNomDescriptionMock,
  meublesImageNomMock,
  meublesMock,
  modeleListingMock,
  packElectroMock,
  packEviersMitigeurs,
  pedagogiePrixMock,
  plansDeTravailMock,
  poigneesMock,
  promoMock,
  realisationsClientListingMagasinMock,
  realisationsClientMurMock,
  temoignagesClientsDetailsMock,
  temoignagesClientsMock,
  tendancesMock,
  tunnelConfirmationMock,
  tunnelStep1Mock,
  tunnelStep2Mock,
  tunnelStep3Mock,
  tutosMock,
} from '@mock/schema/slugs';

export const mock: Mock[] = [
  // {
  //   // method: 'GET',
  //   url: 'common',
  //   schema: commonMock,
  //   // status: 404,
  //   // useStartsWith: true,
  // },
  // {
  //   url: 'common',
  //   patch: addFeaturedLinksMock,
  // },
  // {
  //   url: 'pricedetail',
  //   schema: priceDetailMock,
  //   useStartsWith: true,
  //   delay: 2500,
  // },
  // {
  //   url: 'timeslots',
  //   apiEndpoint: 'timeslots',
  //   schema: timeslotsMock,
  //   useStartsWith: true,
  //   delay: 2500,
  // },
  {
    url: 'slug?slug=mock-homepage',
    schema: homepageMock,
  },
  {
    url: 'slug?slug=mock-tendances',
    schema: tendancesMock,
  },
  {
    url: 'slug?slug=mock-cuisines',
    schema: modeleListingMock,
  },
  {
    url: 'slug?slug=mock-temoignages-clients',
    schema: temoignagesClientsMock,
  },
  {
    url: 'slug?slug=mock-temoignages-clients/',
    useStartsWith: true,
    schema: temoignagesClientsDetailsMock,
  },
  {
    url: 'slug?slug=mock-estimateur-budget',
    schema: estimateurBudgetMock,
  },
  {
    url: 'slug?slug=mock-estimateur-budget-step-1',
    schema: estimateurBudgetStep1Mock,
  },
  {
    url: 'slug?slug=mock-estimateur-budget-recap',
    schema: estimateurBudgetRecapMock,
  },
  {
    url: 'slug?slug=mock-pack-electro',
    schema: packElectroMock,
  },
  {
    url: 'slug?slug=mock-pack-eviers-mitigeurs',
    schema: packEviersMitigeurs,
  },
  {
    url: 'slug?slug=mock-listing-cuisines',
    schema: listingCuisineMock,
  },
  {
    url: 'slug?slug=mock-modeles',
    schema: detailsCusineMock,
    useStartsWith: true,
  },
  {
    url: 'slug?slug=mock-tunnel-step-1',
    schema: tunnelStep1Mock,
  },
  {
    url: 'slug?slug=mock-tunnel-step-2',
    schema: tunnelStep2Mock,
  },
  {
    url: 'slug?slug=mock-tunnel-step-3',
    schema: tunnelStep3Mock,
  },
  {
    url: 'slug?slug=mock-tunnel-confirmation',
    schema: tunnelConfirmationMock,
  },
  // {
  //   url: 'slug?slug=mock-tunnel-confirmation-espace-client',
  //   schema: tunnelConfirmationEspaceClientMock,
  // },
  {
    url: 'slug?slug=mock-magasin',
    schema: magasinMock,
  },
  {
    url: 'slug?slug=mock-coin-repas',
    schema: coinRepasMock,
  },
  {
    url: 'slug?slug=mock-la-pose',
    schema: laPoseMock,
  },
  {
    url: 'slug?slug=mock-la-pose/pro',
    schema: laPoseProMock,
  },
  {
    url: 'slug?slug=mock-la-pose/perso',
    schema: laPosePersoMock,
  },
  {
    url: 'slug?slug=mock-tutos/',
    useStartsWith: true,
    schema: detailTutoMock,
  },
  {
    url: 'slug?slug=mock-tutos',
    schema: tutosMock,
  },
  {
    url: 'slug?slug=mock-facades/categories',
    schema: categoriesFacadesMock,
  },
  {
    url: 'slug?slug=mock-meubles',
    schema: meublesMock,
  },
  {
    url: 'slug?slug=mock-facades/',
    useStartsWith: true,
    schema: listingFacadesMock,
  },
  {
    url: 'slug?slug=mock-plans-de-travail',
    schema: plansDeTravailMock,
  },
  {
    url: 'slug?slug=mock-corps-de-meuble',
    schema: corpsDeMeubleMock,
  },
  {
    url: 'slug?slug=mock-poignees',
    schema: poigneesMock,
  },
  {
    url: 'slug?slug=mock-meubles-niches-etageres',
    schema: meublesImageNomMock('Niches et étagères'),
  },
  {
    url: 'slug?slug=mock-meubles-amenagement-des-meubles',
    schema: meublesImageNomMock('Aménagement des meubles'),
  },
  {
    url: 'slug?slug=mock-meubles-accessoires',
    schema: meublesImageNomMock('Accessoires'),
  },
  {
    url: 'slug?slug=mock-meubles-hauts',
    schema: meublesImageNomDescriptionMock('Meubles hauts'),
  },
  {
    url: 'slug?slug=mock-meubles-bas',
    schema: meublesImageNomDescriptionMock('Meubles bas'),
  },
  {
    url: 'slug?slug=mock-armoires',
    schema: meublesImageNomDescriptionMock('Armoires'),
  },
  {
    url: 'slug?slug=mock-promo',
    schema: promoMock,
  },
  {
    url: 'slug?slug=mock-blog-article/',
    useStartsWith: true,
    schema: blogArticleMock,
  },
  {
    url: 'slug?slug=mock-blog-b2c/inspiration/agencement',
    schema: blogB2cInspirationMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise/blog',
    useStartsWith: true,
    schema: blogB2cMock,
  },
  {
    url: 'slug?slug=mock-faq-detail/',
    useStartsWith: true,
    schema: faqDetailsMock,
  },
  {
    url: 'slug?slug=mock-pedagogie-prix',
    schema: pedagogiePrixMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise/etapes-projet',
    schema: franchiseEtapesProjetMock,
  },
  {
    url: 'slug?slug=mock-catalogue',
    schema: catalogueMock,
  },
  {
    url: 'slug?slug=mock-contact',
    schema: contactMock,
  },
  {
    url: 'slug?slug=mock-lp-simple',
    schema: lpSimpleMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise',
    schema: franchiseHomepageMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise/des-cuisinistes-pas-comme-les-autres',
    schema: franchiseCuisinistesMock,
  },
  {
    url: 'slug?slug=mock-confidentialite',
    schema: confidentialiteMock,
  },
  {
    url: 'slug?slug=mock-mentions-legales',
    schema: mentionsLegalesMock,
  },
  {
    url: 'slug?slug=mock-erreur',
    schema: erreurMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise/les-chiffres-qui-comptent',
    schema: franchiseChiffresMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise/contact',
    schema: contactB2bMock,
  },
  {
    url: 'slug?slug=mock-carte-opportunites',
    schema: carteOpportunitesPageMock,
  },
  {
    url: 'slug?slug=mock-faq-listing',
    schema: faqListingMock,
  },
  {
    url: 'slug?slug=mock-lp-sem-sommaire',
    schema: lpSemSommaireMock,
  },
  {
    url: 'slug?slug=mock-cuisine-sur-mesure',
    schema: cuisineSurMesureMock,
  },
  // {
  //   url: 'slug?slug=mock-lp-configurateur',
  //   schema: lpConfigurateurMock,
  // },
  {
    url: 'slug?slug=mock-listing-magasin/region',
    schema: listingMagasinPageMock('region'),
  },
  {
    url: 'slug?slug=mock-listing-magasin/dept',
    schema: listingMagasinPageMock('dept'),
  },
  {
    url: 'slug?slug=mock-listing-magasin/magasins-france',
    schema: listingMagasinPageMock('all'),
  },
  {
    url: 'slug?slug=mock-lp-sem-filtre/cuisine-blanche',
    schema: lpSemPageFiltreMock({ front: ['Blanc'] }),
  },
  {
    url: 'slug?slug=mock-realisations-client/listing-magasin',
    schema: realisationsClientListingMagasinMock,
  },
  {
    url: 'slug?slug=mock-realisations-client/mur',
    schema: realisationsClientMurMock,
  },
  {
    url: 'slug?slug=mock-catalogue/consultation',
    schema: catalogueConsultationMock,
  },
  {
    url: 'slug?slug=mock-espace-franchise/confirmation_envoi_formulaire_contact',
    schema: confirmationEnvoiFormulaireContactMock,
  },
];
